export const apiName: string = 'templates';
export const templateStorage: string = 'template';

export const templateQuery: any = {
    "where":{
        "ativo":true,
        "nome":{"regexp":"/REPLACEHERE/i"}
    },
    "order":"nome"
};


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/templates/data.service.ts
 **/